'use strict'

import Vue from 'vue'
import axios from 'axios'

const token = JSON.parse(localStorage.getItem('sts-token') || '{}') || null
if (token) {
    axios.defaults.headers.common['X-Access-Token'] = token.token
}

let config = {
    baseURL: process.env.VUE_APP_API_URL + process.env.VUE_APP_API_VERSION
}

const _axios = axios.create(config)

_axios.interceptors.request.use(
    function(config) {
        // Do something before request is sent
        return config
    },
    function(error) {
        // Do something with request error
        return Promise.reject(error)
    }
)

// Add a response interceptor
_axios.interceptors.response.use(
    function(response) {
        // Do something with response data
        return response
    },
    function(error) {
        // Do something with response error
        return Promise.reject(error)
    }
)

Plugin.install = function(Vue) {
    Vue.api = _axios
    window.api = _axios
    Object.defineProperties(Vue.prototype, {
        api: {
            get() {
                return _axios
            }
        },
        $api: {
            get() {
                return _axios
            }
        }
    })
}

Vue.use(Plugin)

export default Plugin
